import { render, staticRenderFns } from "./VideoApproveModal.vue?vue&type=template&id=31c29c0d&"
import script from "./VideoApproveModal.vue?vue&type=script&lang=js&"
export * from "./VideoApproveModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports